import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { STORAGE_KEYS } from '@utils/constants'
import type { AuthState, User } from './authTypes'

const readUser = (): User | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.user)
    return raw ? (JSON.parse(raw) as User) : null
  } catch {
    return null
  }
}

const initialState: AuthState = {
  token: localStorage.getItem(STORAGE_KEYS.token),
  user: readUser(),
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<{ token: string; user: User }>) => {
      state.token = action.payload.token
      state.user = action.payload.user
      localStorage.setItem(STORAGE_KEYS.token, action.payload.token)
      localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(action.payload.user))
    },
    logout: (state) => {
      state.token = null
      state.user = null
      localStorage.removeItem(STORAGE_KEYS.token)
      localStorage.removeItem(STORAGE_KEYS.user)
    },
  },
})

export const { setCredentials, logout } = authSlice.actions
export default authSlice.reducer
